import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import {
  Container,
  Typography,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import './stylemod.css';
import OBProduction from '../layouts/dashboard/nav/OBProduction';
// hooks
import useResponsive from '../hooks/useResponsive';
import logoImage from '../media/ob.png';
import bg4 from '../media/bg7.png';
import Iconify from '../components/iconify';
import axios from '../axiosConfig';


const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundImage: `url("${bg4}")`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  mixBlendMode: 'multiply',
}));

const currentYear = new Date().getFullYear();
const fiscalYears = Array.from({ length: 10 }, (_, i) => {
  const startYear = currentYear - i;
  const endYear = startYear + 1;
  return `${startYear} - ${endYear}`;
});
const LoadingScreen = []

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const navigate = useNavigate();
  const [company, setCompany] = useState(0);
  const [factory, setFactory] = useState(0);
  const [unitData, setUnitData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [fiscalYear, setFiscalYear] = useState(fiscalYears[0]);
  const [showUserPassword, setShowUserPassword] = useState(false);
  const [UserName, setUserName] = useState('');
  const [UserPassword, setUserPassword] = useState('');
  const [error, setError] = useState('');
  const [errorColor, setErrorColor] = useState('');

  // get one UserData Request
  const GetOneUserAccess = async (id) => {
    try {
      LoadingScreen.length = 0;
      const res = await axios.instance.get(`/GetOneUserAccess/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      if (res.data.length > 0) {
        res.data.forEach((item) => {
          sessionStorage.setItem(item.ShortName, item.Access);
          if(item.Category === 'OBProduction' && item.Access === 'Y')
          {
            LoadingScreen.push(item)
          }
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all factory data
  const GetCompanyBasedFactories = async (compID) => {
    try {
      const res = await axios.instance.get(`/GetCompanyBasedFactories/${compID}/${UserName}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setFactory(res.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleClick = async () => {
    if (!UserName) {
      setError('please enter user name');
      setErrorColor('error');
      setTimeout(() => {
        setError('');
        setErrorColor('');
      }, 3000);
    } else if (!UserPassword) {
      setError('please enter password');
      setErrorColor('error');
      setTimeout(() => {
        setError('');
        setErrorColor('');
      }, 3000);
    }

    if (!UserName || !UserPassword) {
      return;
    }

    try {
      const response = await axios.instance.post(
        '/UserLogin',
        { UserName, UserPassword, Company_Id: company },
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
      // console.log('response data', response.data[0]);
      const data = response.data[0];
      if (data.ActiveStatus === 'Y' && data.loginAccess === 'Y') {
        setError('login Successsful');
        setErrorColor('green');

        // save in session storage
        sessionStorage.setItem('User_Name', data.UserName);
        sessionStorage.setItem('User_EMail', data.Email);
        sessionStorage.setItem('PhoneNumber', data.PhoneNumber);
        sessionStorage.setItem('Gender', data.Gender);
        sessionStorage.setItem('loginAccess', data.loginAccess);
        sessionStorage.setItem('UserID', data.UserAccessID);
        sessionStorage.setItem('UserCode', data.UserCode);
        sessionStorage.setItem('DepartmentId', data.DepartmentId);
        sessionStorage.setItem('DepartmentDescription', data.DepartmentDescription);
        sessionStorage.setItem('DesignationId', data.DesignationId);
        sessionStorage.setItem('DesignationDescription', data.DesignationDescription);
        sessionStorage.setItem('LoginStatus', data.ActiveStatus);
        sessionStorage.setItem('CompanyId', data.Company_Id);
        sessionStorage.setItem('Company_Name', data.Company_Name);
        sessionStorage.setItem('FiscalYear', fiscalYear);
        sessionStorage.setItem('factoryID', factory.Unit_Id);
        sessionStorage.setItem('factoryName', factory.Unit_Name);
        sessionStorage.setItem('SplUser', data.SplUser);

      await GetOneUserAccess(data.UserAccessID); 
        const hasDashboardAccess = sessionStorage.getItem('Dashboard') === 'Y';
        const matched = OBProduction.find(menu =>
          LoadingScreen.some(api => api.ShortName === menu.ShortName)
        );
        console.log('matched menu items:', matched);
        setTimeout(() => {
          if (hasDashboardAccess) {
            navigate('/dashboard/home', { replace: true });
          } else if (matched?.path) {
            navigate(matched.path, { replace: true });
          }
          setError('');
          setErrorColor('');
        }, 1000);
      } else {
        setError('Invalid login credentials. Please try again.');
        setErrorColor('error');
        setTimeout(() => {
          setError('');
          setErrorColor('');
        }, 3000);
      }
    } catch (error) {
      setError('Invalid login credentials. Please try again.');
      setErrorColor('error');
      setTimeout(() => {
        setError('');
        setErrorColor('');
      }, 3000);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  // get all Users Request
  const GetCompanyonUserCode = async (value) => {
    try {
      const res = await axios.instance.get(`/GetCompanyonUserCode/${value}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLogData(res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  useEffect(() => {
    if (logData.length > 0) {
      setCompany(logData[0].Company_Id);
      GetCompanyBasedFactories(logData[0].Company_Id);
    } else {
      setCompany(0);
    }
  }, [logData, UserName]);

  const handleFiscalYearChange = (event) => {
    setFiscalYear(event.target.value);
  };

  const handleChange = (event) => {
    setCompany(event.target.value);
    GetCompanyBasedFactories(event.target.value);
  };

  const handleChangeFactory = (event) => {
    setFactory(event.target.value);
  };

  return (
    <>
      <StyledRoot>
        <StyledSection>
          <Container
            maxWidth="md"
            style={{
              backgroundColor: 'inherit',
              borderRadius: '50px',
            }}
            component={Paper}
            elevation={0}
          >
            <Grid
              container
              style={{
                backgroundColor: '#0766AD',
                boxShadow:
                  'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
                minHeight: mdUp ? '60vh' : '40vh',
                maxHeight: mdUp ? '100vh' : '40vh',
                borderRadius: '50px',
              }}
            >
              <Grid item xs={12} md={5} sx={{ maxHeight: mdUp ? '100%' : '30%' }}>
                <Stack
                  justifyContent={'center'}
                  direction={'column'}
                  alignItems={'center'}
                  height={'100%'}
                  className="font_style1"
                >
                  <Stack
                    justifyContent={'center'}
                    direction={'column'}
                    alignItems={'center'}
                    p={5}
                    sx={{ maxHeight: mdUp ? '100%' : '156px' }}
                  >
                    <img
                      src={logoImage}
                      style={{
                        objectFit: 'contain',
                        maxWidth: mdUp ? '100%' : '80px',
                        position: mdUp ? 'relative' : 'absolute',
                        top: mdUp ? 'inherit' : '192px',
                      }}
                      alt="techveel logo"
                    />
                    {mdUp ? (
                      <Typography
                        variant="h4"
                        textAlign={'center'}
                        gutterBottom
                        className="font_style2"
                        style={{ color: 'white' }}
                      >
                        Where Precision Meets Performance
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        textAlign={'center'}
                        style={{ textTransform: 'uppercase', color: 'white' }}
                        gutterBottom
                        sx={{ marginTop: mdUp ? 'inherit' : '40px' }}
                      >
                        Welcome to <br />
                        <span style={{ textTransform: 'uppercase', color: 'white' }} className="font_style2">
                          Operation Bulletin
                        </span>
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12} md={7} justifyContent={'center'} alignItems={'center'}>
                <Stack
                  spacing={3}
                  sx={{ backgroundColor: 'white', p: 3, pb: 3, height: '100%' }}
                  style={{
                    borderTopRightRadius: mdUp ? '50px' : '0px',
                    borderBottomRightRadius: '50px',
                    borderBottomLeftRadius: mdUp ? '0' : '50px',
                  }}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={12}>
                      {mdUp ? (
                        <Typography variant="body2" textAlign={'center'} gutterBottom>
                          Welcome to <br />
                          <span style={{ textTransform: 'uppercase', color: '#0D9276' }} className="font_style2">
                            Operation Bulletin
                          </span>
                          <br />
                          <Typography variant="subtitle2" textAlign={'center'} gutterBottom>
                            Enter Your Credentials
                          </Typography>
                        </Typography>
                      ) : (
                        <Typography variant="subtitle2" textAlign={'center'} gutterBottom>
                          Enter Your Credentials
                        </Typography>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        name="UserName"
                        label="Employee Code"
                        size="small"
                        fullWidth
                        value={UserName}
                        onChange={(e) => {
                          setUserName(e.target.value);
                          GetCompanyonUserCode(e.target.value);
                        }}
                        inputProps={{ autoComplete: 'off' }}
                        autoComplete="off"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        fullWidth
                        name="UserPassword"
                        label="Password"
                        type={showUserPassword ? 'text' : 'password'}
                        autoComplete="off"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={() => setShowUserPassword(!showUserPassword)} edge="end">
                                <Iconify icon={showUserPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={UserPassword}
                        onChange={(e) => setUserPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>

                    <Grid item md={12} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" shrink>
                          Company
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={company}
                          size="small"
                          label="Company"
                          onChange={handleChange}
                        >
                          {logData.map((obj) => (
                            <MenuItem key={obj.Company_Id} value={obj.Company_Id}>
                              {obj.Company_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item md={7} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" shrink>
                          Factory
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={factory}
                          size="small"
                          label="Company"
                          onChange={handleChangeFactory}
                        >
                          {unitData.map((obj) => (
                            <MenuItem key={obj.Unit_Id} value={obj}>
                              {obj.Unit_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="fiscal-year-select-label">Fiscal Year</InputLabel>
                        <Select
                          labelId="fiscal-year-select-label"
                          id="fiscal-year-select"
                          value={fiscalYear}
                          size="small"
                          label="Fiscal Year"
                          onChange={handleFiscalYearChange}
                        >
                          {fiscalYears.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {error && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color={errorColor} sx={{ textAlign: 'center' }}>
                          {error}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <LoadingButton size="small" fullWidth type="submit" variant="contained" onClick={handleClick}>
                        Login
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>{' '}
            </Grid>
          </Container>
        </StyledSection>
      </StyledRoot>
    </>
  );
}
